module.exports = __webpack_public_path__ + "img/UTESCA-5.55b5c05d.jpg";